function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var c = function c(_ref) {
  var n = _ref.height,
      e = _ref.width,
      s = _ref.color,
      i = _ref.iconData;
  var d = {
    "--vds-icon-height": n ? "".concat(n, "px") : "24px",
    "--vds-icon-width": e ? "".concat(e, "px") : "24px"
  };
  return s ? _objectSpread(_objectSpread({}, d), {}, {
    "--vds-icon-background-color": s,
    "--vds-icon-mask-image": "url(\"".concat(i, "\")")
  }, s.includes("gradient") ? {
    "--vds-icon-background-image": s
  } : {}) : _objectSpread(_objectSpread({}, d), {}, {
    "--vds-icon-background-image": "url(\"".concat(i, "\")")
  });
};

export { c as setInlineStyles };